// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA3_comp__G79oa"};